<template>
  <div class="cart-item">
    <a :href="model.url" class="thumb" target="_blank">
      <media :media="media" width="192" />
      <ui-marker
        v-if="isDiscountRateVisible"
        class="cart-item__discount-rate"
        :value="`-${discountRate}%`"
      />
    </a>
    <div class="info">
      <div class="name" v-text="model.name" />
      <p>
        Количество: {{ product.quantity }}<br>
        Цвет: {{ color }}<br>
        Размер: {{ size }}
      </p>
      <div class="prices">
        <div :class="['price price-rub', { discount: discountRate || hasDiscount }]">
          {{ $filters.price(finalPrice) }}
        </div>
        <div
          v-if="discountRate || hasDiscount"
          class="old-price"
        >
          {{ $filters.price(price.basePrice) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDiscount } from '@/composables/product/useDiscount';
import { capitalize } from '@/utils/helpers/string-utils';

export default {
  name: 'cart-item',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const {
      discountRate,
      isDiscountRateVisible,
    } = useDiscount(props.product.models?.[0]?.price);

    return {
      discountRate,
      isDiscountRateVisible,
    };
  },
  computed: {
    model() {
      return this.product.models?.[0] || {};
    },
    color() {
      return capitalize(this.model?.color?.name);
    },
    media() {
      return this.model.media?.[0] || {};
    },
    size() {
      return this.model.skus?.find((sku) => sku.id === this.product.skuId)?.size;
    },
    hasDiscount() {
      return +this.price.basePrice > +this.product.pricePerItem;
    },
    price() {
      return this.model.price || {};
    },
    finalPrice() {
      return Math.floor(this.product.pricePerItem || this.price.discountPrice || this.price.basePrice);
    },
  },
};
</script>

<style lang="scss">
.cart-item {
  display: flex;
  padding: 12px;

  &:not(:last-of-type) {
    box-shadow: inset 0 -1px 0 $gray_lu;
  }

  .thumb {
    position: relative;
    flex: 0 0 96px;
    height: 132px;
    background: $gray_lu;
    margin-right: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__discount-rate {
    position: absolute;
    top: 14px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .name {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;
  }
  p {
    font-size: 12px;
    line-height: 20px;
    color: $gray;
  }
  .prices {
    margin-top: auto;
    display: flex;
    align-items: center;

    .price {
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      &.discount {
        color: $red;
      }
    }

    .old-price {
      color: $gray;
      margin-left: 8px;
      font-weight: normal;
      font-size: 12px;
      text-decoration: line-through;
    }
  }
}
</style>
